import axios from "axios";
import  store  from "../store";
import { setAccessToken } from "../slice/authSlice";
import { logout } from "./authservice";

const api = axios.create({
  baseURL:  process.env.REACT_APP_API_BASE_URL,
});
const getAccessToken = () => store.getState()?.auth?.accessToken;
const getRefreshToken = () => localStorage.getItem("refreshToken");

// ✅ Attach Access Token in headers for every request
api.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Token Refresh Logic
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/app/refresh")
    ) {
      originalRequest._retry = true;
      const refreshToken = getRefreshToken();

      if (!refreshToken) {
        alert("Session expired, please log in again.");
        logout();
        window.location.href = "/login";
        return Promise.reject(error);
      }

      try {
        const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/app/refresh?token=${refreshToken}`);
        const newAccessToken = res.data?.access_token;
        if (!newAccessToken) throw new Error("No access token received!");

        store.dispatch(setAccessToken(newAccessToken));
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (refreshErr) {
        logout();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
